import { Button } from '@app/components/various/Button';
import { Reset as ResetIcon } from '@app/components/various/Icon/Icons/cms/Reset';
import { Tooltip } from '@app/components/various/Tooltip';

interface Props {
  action: () => void;
  name: string;
}

export const Reset = ({ action, name }: Props) => (
  <Tooltip content={name}>
    <Button icon={ResetIcon} onClick={action} color="secondary" />
  </Tooltip>
);
